module.exports = __webpack_public_path__ + "static/media/call_landline.81105259.png";